import { useEffect, useState } from "react";
import { getPublicLegal, fmtDate } from "@/lib/legalApi";
import { PolicyBody } from "@/components/legal/PolicyBody";
import { BrandLogo } from "@/components/brand/AppHeader";
import { BrandName, useBrand } from "@/lib/brand";

export default function PrivacyPolicy() {
  const [doc, setDoc] = useState(null);
  const [missing, setMissing] = useState(false);
  const b = useBrand();
  const privacyEmail = b?.primary ? "steele@badasshorsesales.com" : b?.contact_email || "";
  useEffect(() => {
    document.title = `Privacy Policy | ${window.__brandName || ""}`;
    getPublicLegal("privacy_policy").then(setDoc).catch(() => setMissing(true));
  }, []);
  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <header className="on-dark border-b border-white/10">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-6 pt-[calc(1.5rem+env(safe-area-inset-top))]">
          <div className="mb-4"><BrandLogo className="h-8 sm:h-10 w-auto" /></div>
          <div className="text-[11px] uppercase tracking-[0.2em] font-semibold text-white/70"><BrandName /></div>
          <h1 data-testid="privacy-title" className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight mt-1">Privacy Policy</h1>
          {doc?.entity && <p className="text-sm text-stone-500 mt-1">Operated by {doc.entity}</p>}
          {doc && (
            <p data-testid="privacy-meta" className="text-sm text-stone-500 mt-3">
              Effective Date: <span data-testid="privacy-effective-date" className="text-white font-semibold">{fmtDate(doc.effective_date)}</span>
              <span className="mx-2">·</span>Version <span data-testid="privacy-version" className="text-white font-semibold">{doc.version}</span>
            </p>
          )}
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-6 pb-[calc(2rem+env(safe-area-inset-bottom))]">
        {missing && <p data-testid="privacy-unavailable" className="rounded-xl border border-stone-200 bg-white p-4 text-sm text-stone-700">Our Privacy Policy is being updated. For privacy questions, contact <a href={`mailto:${privacyEmail}`} className="text-amber-800 underline">{privacyEmail}</a>.</p>}
        {!doc && !missing && <p className="text-sm text-stone-500">Loading…</p>}
        {doc && (
          <article className="rounded-xl border border-stone-200 bg-white p-4 sm:p-8">
            <PolicyBody html={doc.html} />
            <footer data-testid="privacy-contact" className="mt-8 border-t border-stone-200 pt-4 text-sm text-stone-600">
              {doc.entity}, operating as <BrandName /> · Privacy contact: <a href={`mailto:${doc.contact}`} className="text-amber-800 underline">{doc.contact}</a>
            </footer>
          </article>
        )}
      </main>
    </div>
  );
}
